import { createResponsiveStateReducer } from 'redux-responsive';
import { BREAKPOINTS, INFINITY } from '../actions/browser.types';

const STORE_KEY = 'browser';
export const selectBrowserState = state => state[STORE_KEY];
export const selectBrowserMediaType = state => state[STORE_KEY].mediaType;

export default initialMediaType => createResponsiveStateReducer(
  BREAKPOINTS,
  {
    infinity: INFINITY,
    initialMediaType,
  });



// WEBPACK FOOTER //
// ./src/store/reducers/browser.js